import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonType } from '@src/components/Button'
import { MainRouteName, useAccountRouter } from '@src/hooks/useAccountRouter'
import { useCheckoutRouter } from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { useHasActiveOrders } from '@src/hooks/useHasActiveOrders'

import {
  EmptyBasketContainer,
  EmptyBasketOuterContainer,
  StyledBasketSVG,
} from './EmptyBasket.styles'

export const EmptyBasket: React.FC = () => {
  const { t } = useTranslation('checkout')
  const accountRouter = useAccountRouter()
  const checkoutRouter = useCheckoutRouter()
  const { hasActiveOrders } = useHasActiveOrders()
  return (
    <EmptyBasketOuterContainer data-test-id="basket-container-empty">
      <EmptyBasketContainer>
        <StyledBasketSVG
          id="navigation-basket"
          title={t('basket_icon_alt')}
          data-test-id="basket-icon-emptybasket"
        />
        <p data-test-id="basket-text-emptybasket">{t('empty_basket')}</p>
      </EmptyBasketContainer>
      {hasActiveOrders && (
        <Button
          onClick={() => {
            checkoutRouter.reset()
            accountRouter.setRoute({
              mainRouteName: MainRouteName.ORDERS,
            })
          }}
          buttonType={ButtonType.TERTIARY}
          content={t('view_active_orders')}
          data-test-id="basket-button-viewactiveorders"
        />
      )}
    </EmptyBasketOuterContainer>
  )
}
